import ExternalAccountsAndCards from 'features/myVaro/screens/ExternalAccounts/ExternalAccountsAndCards';
import React from 'react';

export default function ExternalAccountsPage() {
  return <ExternalAccountsAndCards />;
}
